module.exports = __webpack_public_path__ + "static/media/bg2.a8d17a23.jpg";